import validate from "C:/Users/Charl/Downloads/ipa-lms-live/node_modules/nuxt/dist/pages/runtime/validate.js";
import _001_45portal_45redirect_45global from "C:/Users/Charl/Downloads/ipa-lms-live/middleware/001-portal-redirect.global.ts";
import _002_45native_45return_45global from "C:/Users/Charl/Downloads/ipa-lms-live/middleware/002-native-return.global.ts";
import auth_45global from "C:/Users/Charl/Downloads/ipa-lms-live/middleware/auth.global.ts";
import breadcrumb_45tracker_45global from "C:/Users/Charl/Downloads/ipa-lms-live/middleware/breadcrumb-tracker.global.ts";
import manifest_45route_45rule from "C:/Users/Charl/Downloads/ipa-lms-live/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _001_45portal_45redirect_45global,
  _002_45native_45return_45global,
  auth_45global,
  breadcrumb_45tracker_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "chukkers-guard": () => import("C:/Users/Charl/Downloads/ipa-lms-live/middleware/chukkers-guard.ts"),
  "feature-flag-guard-utils": () => import("C:/Users/Charl/Downloads/ipa-lms-live/middleware/featureFlagGuardUtils.ts"),
  "gallery-guard": () => import("C:/Users/Charl/Downloads/ipa-lms-live/middleware/gallery-guard.ts"),
  "leaderboard-guard": () => import("C:/Users/Charl/Downloads/ipa-lms-live/middleware/leaderboard-guard.ts"),
  "staging-only": () => import("C:/Users/Charl/Downloads/ipa-lms-live/middleware/staging-only.ts"),
  "tournaments-guard": () => import("C:/Users/Charl/Downloads/ipa-lms-live/middleware/tournaments-guard.ts")
}